var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDrying = function SvgDrying(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.564 11.168C18.268 12.616 18.628 13.792 18.628 14.664C18.656 17.748 16.564 20.448 13.572 21.196C10.58 21.944 7.46797 20.536 6.04397 17.8L7.04397 17.232C8.23596 19.484 10.808 20.636 13.28 20.024C15.752 19.412 17.492 17.196 17.496 14.648C17.496 13.896 17.136 12.86 16.584 11.72L17.564 11.168ZM20.68 6.15597L21.424 7.44397L3.41197 17.844L2.66797 16.556L20.68 6.15597ZM11.944 2.66797L12.4 3.22397C12.412 3.24397 13.964 5.20397 15.488 7.53596V7.55596L14.504 8.12396C13.592 6.71997 12.644 5.41197 11.944 4.49597C10.52 6.36397 8.06796 9.85196 6.96397 12.48L5.46397 13.344C5.86397 11.872 6.85197 9.93996 8.41596 7.53596C9.94396 5.19597 11.504 3.24397 11.504 3.22397L11.944 2.66797Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDrying, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Drying.be7f38a4.svg";
export { ForwardRef as ReactComponent };